<template>
	<div class="con1 fl_r fl_j_s fl_a_c">
		<div class="con1_l">
			<img src="../assets/1.png">
		</div>
		<div class="con1_r fl_r fl_j_s fl_a_c">
			<div class="con1_r_i fl_r fl_j_c fl_a_c" v-for="(x,y) in navlist" :key="y" @click="changtans(y,x.url)">
				<div :class="[index == y ? 'con1_r_i_ls':'con1_r_i_l']">{{x.name}}</div>
				<div class="con1_r_i_r" v-if="y == 1">HOT</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Nav',
		props: {
			index: 0,
		},
		data () {
			return {
				navlist: [{
					name: '首页',
					active: false,
					url: "/"
				}, {
					name: '供求信息',
					active: false,
					url: "/gqxx"
				}, {
					name: '汇旺公群',
					active: false,
					url: '/hwgq'
				}, {
					name: '防骗指南',
					active: false,
					url: "/fp"
				}, {
					name: '联系我们',
					active: false,
					url: '/contact'
				}, {
					name: '关于我们',
					active: false,
					url: "/about"
				}, ]
			}
		},
		methods: {
			changtans (index, url) {
				this.$router.push(url)
				this.$emit('change', index);
			}
		},
	}
</script>
<style lang="less" scoped>
	.con1 {
		width: 100%;
		height: 80px;
		background: #FFFFFF;
		box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1);

		.con1_l {
			margin-left: 30px;

			img {
				width: 150px;
				height: 65px;
				display: block;
			}
		}

		.con1_r {
			margin-left: 60px;

			.con1_r_i {
				width: 100px;
				cursor: pointer;

				.con1_r_i_l {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 16px;
					color: #202020;
					line-height: 0px;
					text-align: center;
				}

				.con1_r_i_ls {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 16px;
					color: #202020;
					line-height: 0px;
					text-align: center;
				}

				.con1_r_i_r {
					font-family: PingFang SC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #E10109;
					line-height: 0px;
					text-align: left;
					padding-left: 2px;
				}
			}
		}
	}
</style>